import React from "react";
import PageShell from "../../layout/components/PageShell";

interface AccountPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Shell for the account pages. The chrome itself lives in the shared
 * `PageShell` (the acceptance screen renders the same one); this stays as the
 * name the account pages import.
 */
const AccountPageLayout: React.FC<AccountPageLayoutProps> = ({
  title,
  children,
}) => <PageShell title={title}>{children}</PageShell>;

export default AccountPageLayout;
